import * as i0 from "@angular/core";
var Globals = /** @class */ (function () {
    function Globals() {
    }
    Globals.ngInjectableDef = i0.defineInjectable({ factory: function Globals_Factory() { return new Globals(); }, token: Globals, providedIn: "root" });
    return Globals;
}());
export { Globals };
var TokenManager = /** @class */ (function () {
    function TokenManager() {
    }
    TokenManager.prototype.store = function (tokenKey, content) {
        sessionStorage.setItem(tokenKey, JSON.stringify(content));
    };
    TokenManager.prototype.retrieve = function (tokenKey) {
        var storedToken = sessionStorage.getItem(tokenKey);
        if (!storedToken)
            return null;
        return storedToken;
    };
    TokenManager.prototype.retrieveToken = function (tokenKey) {
        var currentTime = (new Date()).getTime(), token = null;
        try {
            var storedToken = JSON.parse(this.retrieve(tokenKey));
            if (storedToken.ttl < currentTime)
                throw 'invalid token found';
            token = storedToken.token;
        }
        catch (err) {
            console.error(err);
        }
        return token;
    };
    TokenManager.prototype.clear = function () {
        sessionStorage.clear();
    };
    TokenManager.prototype.delete = function (tokenKey) {
        sessionStorage.removeItem(tokenKey);
    };
    TokenManager.ngInjectableDef = i0.defineInjectable({ factory: function TokenManager_Factory() { return new TokenManager(); }, token: TokenManager, providedIn: "root" });
    return TokenManager;
}());
export { TokenManager };
